import { SVGProps } from 'react';

// PayPal icon
export function PayPalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 2.72a.77.77 0 0 1 .76-.64h6.263c2.075 0 3.712.566 4.867 1.682 1.155 1.117 1.642 2.685 1.448 4.666-.209 2.139-1.082 3.857-2.595 5.106-1.482 1.224-3.41 1.847-5.733 1.847H7.926a.77.77 0 0 0-.76.64l-.73 4.576a.641.641 0 0 1-.633.54h-.728zM19.85 7.92c-.214 2.19-1.348 3.91-2.917 5.03-1.498 1.068-3.33 1.63-5.436 1.63H9.47l-.937 5.88h3.543a.538.538 0 0 0 .532-.452l.022-.113.422-2.67.027-.147a.538.538 0 0 1 .531-.452h.335c2.162 0 3.854-.44 5.089-1.318 1.298-.921 2.174-2.295 2.476-3.92.127-.684.155-1.312.09-1.883-.043-.378-.127-.72-.25-1.025-.034-.083-.07-.163-.11-.24a6.73 6.73 0 0 0-.39-.32z"/>
    </svg>
  );
}

// Stripe icon
export function StripeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z"/>
    </svg>
  );
}

// NatWest icon (simplified N logo)
export function NatWestIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
      <path d="M9 7h2v10H9zm4 0h2l2 6v-6h2v10h-2l-2-6v6h-2z"/>
    </svg>
  );
}

// Starling Bank icon
export function StarlingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="12" cy="12" r="4"/>
    </svg>
  );
}

// Monzo icon
export function MonzoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
      <path d="M7 10h10M7 14h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

// Revolut icon
export function RevolutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2L3 7v10l9 5 9-5V7l-9-5zm0 2.18l6.36 3.53L12 11.24 5.64 7.71 12 4.18zM5 8.81l6 3.33v5.68l-6-3.33V8.81zm8 9.01v-5.68l6-3.33v5.68l-6 3.33z"/>
    </svg>
  );
}
